import React from 'react';
import { formatMoney } from './quickPriceListModel';

const QuickPriceRuleEquivalent = ({ equivalent, margin, ruleMode, basis = 'unit', id }) => {
  if (!equivalent) return null;

  let label;
  if (equivalent.unavailable === 'missing_cost') {
    label = 'Equivalente: falta costo calculado.';
  } else if (equivalent.unavailable === 'zero_cost') {
    label = 'Equivalente: no se puede calcular % con costo $0.';
  } else if (equivalent.unavailable === 'unresolved_rule') {
    label = 'Equivalente: pendiente de costo o tramo válido.';
  } else if (equivalent.unavailable) {
    label = 'Equivalente no disponible.';
  } else if (margin) {
    const percent = margin.percent === null ? '% no disponible'
      : `${margin.percent.toLocaleString('es-CL', { maximumFractionDigits: 2 })}%`;
    const amount = ruleMode === 'markup_amount'
      ? `${formatMoney(margin.amount)}${basis === 'kg' ? ' / kg' : ''} ≈ ` : '';
    label = `Margen: ${amount}${percent}`;
  } else if (equivalent.mode === 'amount') {
    label = `Equivalente: ≈ ${formatMoney(equivalent.value)}${basis === 'kg' ? ' / kg' : ''}`;
  } else {
    label = `Equivalente: ≈ ${equivalent.value.toLocaleString('es-CL', { maximumFractionDigits: 2 })}%`;
  }

  return (
    <p
      id={id}
      className="mt-1 text-[11px] leading-tight text-slate-500"
      title={`Equivalente sobre el costo calculado ${basis === 'kg' ? 'por kg' : 'por unidad'}, antes del redondeo del precio final.`}
    >
      {label}
    </p>
  );
};

export default QuickPriceRuleEquivalent;
